<template lang="html">
  <div class="l-container">
    <div
      class="l-user-item iconfont"
      :class="{ selected: item.name == tab }"
      v-for="(item, index) in options"
      :key="index"
      @click="handleTabClick(item, index)"
    >
      <i :class="item.icon" class="l-user-item-icon"></i>
      <span class="l-user-item-text">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isAdmin:false,
      options: [
        {
          icon: 'icon-yonghuquanxian',
          text: this.$t('user.personal-center'),
          name: 'user-personal-center'
        },
        {
          icon: 'icon-yonghushouce',
          text: this.$t('user.manual'),
          name: 'user-manual'
        },
        {
          icon: 'icon-yonghushouce',
          text: this.$t('user.authorizelm'),
          name: 'user-authorizelm'
        },
        {
          icon: 'icon-yonghushouce',
          text: this.$t('user.authorizedlevel'),
          name: 'user-authorizedlevel'
        }
      ]
    };
  },
  props: {
    tab: {
      // 当前选中的是第几个 选项
      type: Number | String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    handleTabClick(item, index) {
      if (index + 1 != this.tab) {
        this.$router.push({
          name: item.name
        });
      }
    }
  },
  mounted() {
    let tempOptions = [];
    if(this.$hasPermissionByRouteName(this.options[0].name)) {
      tempOptions.push(this.options[0]);
    }
    tempOptions.push(this.options[1]);
    for (let index = 0; index < this.userInfo.roleCodes.length; index++) {
      const element = this.userInfo.roleCodes[index];
      if(element == 140) {
          this.isAdmin = true
          tempOptions.push(this.options[2]);
          tempOptions.push(this.options[3]);
          break
      }
    }
    
    if(!this.isAdmin) {
      for (const key in this.userInfo.meetingApproveRole) {
          if(key == 135) {
            tempOptions.push(this.options[2]);
          }
          if(key == 198) {
            tempOptions.push(this.options[3]);
          }
        }
    }

    this.options = tempOptions;
  }
};
</script>

<style lang="less" scoped>
.l-user-item {
  width: 100%;
  height: 57px;
  padding: 18px 22px;
  border-bottom: 1px solid #dfdfdf;
  display: flex;
  align-items: center;

  &-icon {
    font-size: 16px;
    padding: 2px;
    font-style: normal;
  }

  &-text {
    margin-left: 7px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    display: inline-block;
  }

  &:hover {
    color: @mainColor;
    cursor: pointer;
  }

  &:last-child {
    border-bottom: none;
  }
}

.selected {
  color: @mainColor;
}
</style>



// WEBPACK FOOTER //
// LeftBar.vue?0aba0fe2